import { Component, HostBinding, OnInit } from '@angular/core';

@Component({
  selector: 'app-dav-param',
  templateUrl: './dav-param.component.html',
  styleUrls: ['./dav-param.component.scss']
})
export class DavParamComponent implements OnInit {
  @HostBinding('class.clamp') clamp = true;

  constructor() { }

  ngOnInit() {
  }

}
